import PriceFormat from '@website/components/utilities/PriceFormat';
import { Currency } from '@website/types/graphqlOperations';
import { DepositNonRefundableMessage } from './BalanceRefundCancel';

export default function BalanceRefundChangeDates({
  guestRefund,
  guestCredits,
  currency,
}: {
  guestRefund: number;
  guestCredits: number;
  currency: Currency;
}) {
  // If there is no credit available, it must be a non-refundable deposit trip
  if (!guestCredits) {
    if (!guestRefund) {
      return (
        <div>
          <h6>
            Unfortunately it's no longer possible to get a refund or change
            dates
          </h6>

          <DepositNonRefundableMessage />
        </div>
      );
    }

    // If the balance is already paid
    return (
      <div>
        <h6>Here's how it works</h6>
        <ul>
          <li>You should firstly cancel the existing spaces below.</li>

          <li>
            You'll get a partial refund of{' '}
            <PriceFormat amount={guestRefund} currencyIso={currency} />, for the
            balance that you paid.
          </li>

          <li>
            You won't get a credit for the deposit however, as unfortunately
            this part is non-refundable for this specific trip (it's used to
            purchase non-refundable permits).
          </li>

          <li>
            After doing this, you can then go ahead and book a new date, on the
            trip page.
          </li>
        </ul>

        <DepositNonRefundableMessage />
      </div>
    );
  }

  return (
    <div>
      <h6>Here's how it works</h6>

      <p>
        Great news - as you are more than 2 months before the start of the trip,
        you're eligible for a free date change. You can also change the trip
        entirely.
      </p>

      <p>The way this works is as follows:</p>

      <ul>
        <li>You should firstly cancel the existing spaces below.</li>

        <li>
          This will result in a credit of{' '}
          <PriceFormat amount={guestCredits} currencyIso={currency} /> being
          applied to your Skyhook account.
        </li>

        <li>
          You can then use this credit to book a new date, or a different trip.
          It can be applied to the deposit of any trip, but please note it
          cannot be applied to the balance payment.
        </li>

        {guestRefund > 0 && (
          <li>
            You'll also get a refund of{' '}
            <PriceFormat amount={guestRefund} currencyIso={currency} />. This is
            because we can't move the balance payment across automatically, so
            instead we refund that part to you.
          </li>
        )}

        <li>
          You'll be able to use the credit instantly - it will show
          automatically on the checkout page for your new booking (under the
          credits section). If for any reason you can't see it there, just let
          us know first.
        </li>
      </ul>
    </div>
  );
}
